import React from "react";

const POINTS = [
  {
    k: "01",
    title: "Proactive, not reactive",
    body: "We work the gap before escalation — the conditions phase, not the crisis phase.",
  },
  {
    k: "02",
    title: "Non-clinical by design",
    body: "We do not diagnose or treat. We stabilize the environment in which other care is delivered.",
  },
  {
    k: "03",
    title: "Doctrine-led, repeatable",
    body: "A codified operational architecture means consistent quality at scale.",
  },
  {
    k: "04",
    title: "Welfare-driven",
    body: "Canine welfare is the foundation of reliability — not an afterthought to it.",
  },
];

export default function WhyMSWDC() {
  return (
    <section
      data-testid="why-mswdc"
      className="relative grain bg-[#0F172A] text-white overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="brand-rule" />
              <span className="overline !text-amber-500">Why MSWDC</span>
            </div>
            <h2 className="mt-6 font-display font-black text-3xl md:text-5xl tracking-tight leading-[1.05]">
              A measurable, codified system —
              <span className="text-amber-500"> not a feel-good visit.</span>
            </h2>
            <p className="mt-8 text-slate-300 max-w-md leading-relaxed">
              MSWDC is built to integrate with institutional realities: documented protocols,
              defined stop-conditions, and outcomes designed to recover operational capacity.
            </p>
          </div>

          <div className="col-span-12 md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10">
              {POINTS.map((p) => (
                <div key={p.k} data-testid={`why-point-${p.k}`}>
                  <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-500">
                    {p.k}
                  </div>
                  <h3 className="mt-3 font-display font-bold text-xl md:text-2xl text-white">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-slate-400 leading-relaxed text-[15px]">{p.body}</p>
                </div>
              ))}
            </div>

            <blockquote className="mt-16 border-l-2 border-amber-500 pl-6 max-w-2xl">
              <p className="font-display text-xl md:text-2xl leading-snug text-white">
                "Our work is the disciplined practice of standing watch before the crisis —
                so the systems we serve can stay in the work they were built to do."
              </p>
              <footer className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400">
                MSWDC Operating Doctrine
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}
